import React from 'react';
import { ThemeProvider } from '@uhg-abyss/web/ui/ThemeProvider';
import { OverlayProvider } from '@uhg-abyss/web/ui/OverlayProvider';
import { createTheme } from '@uhg-abyss/web/tools/theme';
import { Provider } from 'react-redux';
import { store } from '@src/store/reduxStore';
import Header from './Header';
import { HeaderBanner } from '../Header/Main/HeaderBanner/HeaderBanner';
import { SiteNotifications } from '../Header/Main/SiteNotifications/SiteNotifications';
import { ProviderBanner } from '@src/apps/ProviderBanner/ProviderBanner';

const theme = createTheme('uhc', {
  deprecatedFont: true,
});
theme.themeVariantFonts();
const includeBaseCss = false;

interface AppHeaderProps {
  notificationContextKey?: string;
}

export const AppHeader = ({ notificationContextKey }: AppHeaderProps) => {

  return (
    <ThemeProvider theme={theme} includeBaseCss={includeBaseCss}>
      <OverlayProvider>
        <Provider store={store}>
          <div style={{ display: 'flex', flexDirection: 'column' }}>
            <ProviderBanner />
            <SiteNotifications key={notificationContextKey} />
            <HeaderBanner />
            <Header />
          </div>
        </Provider>
      </OverlayProvider>
    </ThemeProvider>
  );
}